import React from "react";

export default function Toggle({ onClick }) {
  return (
    <div onClick={onClick} className="toggle">
      <div />
      <div />
      <div />
    </div>
  );
}
